
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FormCard extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: '#375282' }) readonly color!: string;
  @Prop({ default: '' }) readonly icon!: string;
  @Prop({ default: '' }) readonly subtitle!: string;

  get iconStyles(): Record<string, string> {
    return {
      backgroundColor: this.color,
    };
  }
}
